import { memo, useMemo } from 'react';
import LangEnum from '../../../../../../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../../../../../../translation/TranslationContext';
import SelloutRowMobile from '../../../../mobile/components/SelloutRowMobile';
import useSelloutDistributionRow from '../../../hooks/useSelloutDistributionRow';
import { SelloutDistributionRowComponentProps } from '../../../types/selloutDistributionRow.types';
import SelloutDistributionRowItem from '../../item/components/SelloutDistributionRowItem';
import SelloutDistributionTouchQuantityInput from '../../quantityInput/components/SelloutDistributionTouchQuantityInput';

interface SelloutDistributionRowMobileProps extends SelloutDistributionRowComponentProps {
  pieces: number;
  onChangePieces: (value: number) => void;
}

const SelloutDistributionRowMobile = ({
  pieces,
  disabled,
  selloutSkus,
  distribution,
  onChangePieces,
}: SelloutDistributionRowMobileProps) => {
  const { translate } = useTranslation();
  const { distributionMap, disabledMap } = useSelloutDistributionRow({ distribution });

  const data = useMemo(
    () =>
      selloutSkus.map((sku) => ({
        skuId: sku.skuId,
        sizeName: sku.sizeName ?? '',
      })),
    [selloutSkus],
  );

  return (
    <SelloutRowMobile
      title={translate(LangEnum.GLOBAL_NEW_ORDER)}
      data={data}
      ExtraInput={
        <SelloutDistributionTouchQuantityInput
          pieces={pieces}
          disabled={disabled}
          onChangePieces={onChangePieces}
        />
      }
      renderItem={(sku) => (
        <SelloutDistributionRowItem
          skuId={sku.skuId}
          disabled={disabled}
          disabledMap={disabledMap}
          distributionMap={distributionMap}
        />
      )}
    />
  );
};

export default memo(SelloutDistributionRowMobile);
